import React, { useContext } from "react";
import prefixStyles from "nx-components/utils/prefixStyles";
import Button from "nx-components/Button";
import { Divider } from "nx-components/ItemList";
import RichLabel from "nx-components/RichLabel";
import { IconCloudOff } from "nx-components/Icons";
import AppBarWrapper from "nexia_mobile/components/TopBar/AppBarWrapper";
import CommonAppBarContainer from "nexia_mobile/components/TopBar/CommonAppBarContainer";
import ScrollableArea from "nexia_mobile/components/Scrollable/ScrollableArea";
import Page from "nexia_mobile/components/Page";
import Dispatch from "nexia_mobile/flux_like/dispatch";
import LanguageContext from "nx-components/ContextWrappers/LanguageContext";

const styles = prefixStyles({
  outerWrapper: {
    margin: "auto",
    maxWidth: "25em",
  },
  innerWrapper: {
    margin: "0 1.5em",
    display: "flex",
    flexDirection: "column",
  },
  richLabelWrapper: {
    margin: "0.5em 0",
    fontSize: "1.95em",
    alignSelf: "center",
  },
  richLabelLabelWrapper: {
    padding: "0.25em 0",
  },
});

const InternetRequiredPage = () => {
  const languageContext = useContext(LanguageContext);
  const language =
    languageContext.localeSet.nexia_mobile.pages.InternetRequiredPage;
  return (
    <Page name="InternetRequiredPage" fullyLoaded>
      <AppBarWrapper>
        <CommonAppBarContainer title={language.title} iconRight={null} />
      </AppBarWrapper>
      <ScrollableArea>
        <div style={styles.outerWrapper}>
          <div style={styles.innerWrapper}>
            <div style={styles.richLabelWrapper}>
              <RichLabel
                icon={<IconCloudOff />}
                iconStyle={{ marginLeft: "6px" }}
                label={
                  <div style={styles.richLabelLabelWrapper}>
                    {language.serviceUnavailableLabel}
                  </div>
                }
              />
            </div>
            <Divider />
            <p style={{ margin: "1em 0" }}>
              {language.serviceUnavailableDescription}
            </p>
            <Button
              full
              onTap={() => {
                Dispatch("CHECK_NETWORK_STATUS");
              }}
            >
              {language.retryButton}
            </Button>
          </div>
        </div>
      </ScrollableArea>
    </Page>
  );
};

export default InternetRequiredPage;



// WEBPACK FOOTER //
// ./src/components/Pages/InternetRequiredPage.jsx